import { render, staticRenderFns } from "./StandartsCatalogClinRec.vue?vue&type=template&id=f81c9ba0&"
import script from "./StandartsCatalogClinRec.vue?vue&type=script&lang=js&"
export * from "./StandartsCatalogClinRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports